module.exports = __webpack_public_path__ + "static/media/icon.0657ee9d.png";